<template>
    <div class="datetype01">
    <!--2020.12.03 (목) 16:34 형식 -->
          {{displayTime}} 
    </div>
</template>
<script>
import * as moment from "moment/moment";

export default {
    props:['time','type'],
    data(){
        return{           
            created_at:moment(this.time).format('YYYY.MM.DD (dd) hh:mm')
        }
    },
    computed:{
        displayTime(){
            moment.locale("ko")            
            const bt = moment(this.time)
            const ct = moment()
            const diff = ct.diff(bt, 'days')   
            if(diff>0){                    
                if(this.type === 1)
                {
                   return bt.format('YYYY.MM.DD hh:mm:ss')
                }else if(this.type === 1){
                    return bt.format('YYYY.MM.DD (dd) hh:mm')
                }else{
                    return bt.format('MM/DD')
                }      
            }       
            //return moment(this.time).fromNow()
            if(this.type === 1)
                {
                   return bt.format('YYYY.MM.DD (dd) hh:mm')
                }else{
                     return bt.fromNow()
                }
           
        },
        day(){
            moment.locale("ko")
            return moment(this.time).day()
        }
    }
}
</script>
<style lang="scss" scoped>
.datetype01{
    color:#a3a3a3;

}
</style>
